import styled from "styled-components";
import { palette } from "styled-theme";
const ComponentTitleWrapper = styled.h1`
  font-size: 19px;
  font-weight: 500;
  color: ${palette("text", 0)};
  width: 100%;
  margin-right: 17px;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  span:last-child {
    font-size: 0.8rem;
    font-weight: 400;
  }
`;

export { ComponentTitleWrapper };
